import { useEntityPreference } from './useEntityPreference';



import ProfilePicture from "./ProfilePicture";
import SubscribeFullWidthButton from "./SubscribeFullWidthButton";


const SpeakerHeader = ({ speaker }) => {
    const preference = useEntityPreference('speaker', speaker);
    /**
     * A JavaScript function that returns the domain name from a URL.
     * It includes the top-level domain (TLD) unless the TLD is ".com".
     *
     * @param {string} url The input URL string.
     * @returns {string} The formatted domain name.
     */
    const displayURL = (url) => {
        // Check if the URL is valid before proceeding.
        try {
            // Use the built-in URL object for robust parsing.
            const urlObj = new URL(url);
            let hostname = urlObj.hostname; // e.g., "www.wikipedia.org"

            // Split the hostname by the period (.)
            const parts = hostname.split('.'); // e.g., ["www", "wikipedia", "org"]

            // We need at least a domain and a TLD (e.g., "example.com").
            if (parts.length >= 2) {
                const tld = parts[parts.length - 1];
                const domain = parts[parts.length - 2];

                // If the TLD is 'com', return just the domain part.
                if (tld === 'com') {
                    return domain; // e.g., "wikipedia"
                } else {
                    // Otherwise, return the domain and the TLD.
                    return `${domain}.${tld}`; // e.g., "wikipedia.org"
                }
            } else {
                // If the URL has a simple hostname (e.g., "localhost"), just return it.
                return hostname;
            }

        } catch (e) {
            // Return an empty string if the URL is invalid.
            console.error("Invalid URL provided:", url, e);
            return "";
        }
    };


    const canonicalURLs = speaker.canonicalURLs || [];
    const moreInfoURLs = speaker.moreInfoURLs || [];
    const hasSpeakerURLs = canonicalURLs.length > 0 || moreInfoURLs.length > 0;

    return (
        <div>
            <div className='entityHeaderCard speakerHeaderCard'>
                <div className='speakerHeaderTop'>
                    <div className='entityHeaderText speakerHeaderText'>
                        <div className='speakerNameLarge'>
                            {speaker.name}
                        </div>
                        <div className='speakerDescriptionThreeLines'>
                            {speaker.description}
                        </div>
                    </div>

                    <div className='speakerHeaderAvatar'>
                        <ProfilePicture
                            speakerId={speaker.id}
                            followed={preference.status === true}
                            imageLabel={speaker.name}
                            borderSize={2}
                            imageSrc={speaker.imageURL}
                            size='92px'
                        />
                    </div>
                </div>

                {hasSpeakerURLs &&
                    (
                        <div className='speakerURLs'>
                            <div className='speakerURLsInner'>
                                {canonicalURLs.map((canonicalURL, index) => (
                                    <a key={index} href={canonicalURL} target="_blank" className='speakerURL'>
                                        {displayURL(canonicalURL)}
                                    </a>
                                ))}
                                {moreInfoURLs.map((moreInfoURL, index) => (
                                    <a key={index} href={moreInfoURL} target="_blank" className='speakerURL'>
                                        {displayURL(moreInfoURL)}
                                    </a>
                                ))}
                            </div>
                        </div>
                    )
                }

                <div className='entityHeaderSubscribe'>
                    <SubscribeFullWidthButton
                        status={preference.status}
                        onStatusChange={preference.change}
                    />
                </div>
            </div>

        </div>
    );
};

export default SpeakerHeader;
